import { Box, Button, Container, Typography } from '@mui/material';
import { useNavigate } from '../hooks/useNavigate';
import HomeIcon from '@mui/icons-material/Home';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { BaseLayoutFactory } from './global/base-layout-factory';

function PageNotFoundComponent() {
    const navigate = useNavigate();

    return (
        <Container maxWidth="md">
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '60vh',
                    textAlign: 'center',
                    py: 8,
                }}
            >
                <SearchOffIcon
                    sx={{
                        fontSize: 120,
                        color: 'primary.main',
                        mb: 3,
                        opacity: 0.8,
                    }}
                />

                <Typography
                    variant="h1"
                    component="h1"
                    sx={{
                        fontSize: { xs: '4rem', md: '6rem' },
                        fontWeight: 700,
                        color: 'primary.main',
                        mb: 2,
                    }}
                >
                    404
                </Typography>

                <Typography
                    variant="h4"
                    component="h2"
                    sx={{
                        fontSize: { xs: '1.5rem', md: '2rem' },
                        fontWeight: 600,
                        color: 'text.primary',
                        mb: 2,
                    }}
                >
                    Página Não Encontrada
                </Typography>

                <Typography
                    variant="body1"
                    sx={{
                        fontSize: { xs: '0.875rem', md: '1rem' },
                        color: 'text.secondary',
                        mb: 4,
                        maxWidth: 500,
                    }}
                >
                    Desculpe, a página que você está procurando não existe ou foi movida.
                    Verifique o endereço digitado ou retorne à página inicial.
                </Typography>

                <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', justifyContent: 'center' }}>
                    <Button
                        variant="contained"
                        size="large"
                        startIcon={<HomeIcon />}
                        onClick={() => navigate('/')}
                        sx={{
                            px: 4,
                            py: 1.5,
                            fontSize: '1rem',
                            fontWeight: 600,
                            textTransform: 'none',
                        }}
                    >
                        Voltar para o Início
                    </Button>

                    <Button
                        variant="outlined"
                        size="large"
                        onClick={() => navigate(-1)}
                        sx={{
                            px: 4,
                            py: 1.5,
                            fontSize: '1rem',
                            fontWeight: 600,
                            textTransform: 'none',
                        }}
                    >
                        Voltar à Página Anterior
                    </Button>

                    <Button
                        variant="outlined"
                        size="large"
                        endIcon={<OpenInNewIcon />}
                        href="https://docgedsistemas.com.br/"
                        target="_blank"
                        rel="noopener noreferrer"
                        sx={{
                            px: 4,
                            py: 1.5,
                            fontSize: '1rem',
                            fontWeight: 600,
                            textTransform: 'none',
                        }}
                    >
                        Site DocGed
                    </Button>
                </Box>

                <Box sx={{ mt: 6 }}>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                        Links úteis:
                    </Typography>
                    <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', justifyContent: 'center' }}>
                        <Button
                            variant="text"
                            size="small"
                            onClick={() => navigate('/noticias')}
                            sx={{ textTransform: 'none' }}
                        >
                            Notícias
                        </Button>
                        <Button
                            variant="text"
                            size="small"
                            onClick={() => navigate('/contas-publicas')}
                            sx={{ textTransform: 'none' }}
                        >
                            Contas Públicas
                        </Button>
                        <Button
                            variant="text"
                            size="small"
                            onClick={() => navigate('/diario-oficial')}
                            sx={{ textTransform: 'none' }}
                        >
                            Diário Oficial
                        </Button>
                        <Button
                            variant="text"
                            size="small"
                            onClick={() => navigate('/perguntas-respostas')}
                            sx={{ textTransform: 'none' }}
                        >
                            Perguntas Frequentes
                        </Button>
                    </Box>
                </Box>

                <Box sx={{ mt: 4, pt: 4, borderTop: 1, borderColor: 'divider' }}>
                    <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 1 }}>
                        Portal desenvolvido por:
                    </Typography>
                    <Button
                        variant="outlined"
                        size="small"
                        endIcon={<OpenInNewIcon />}
                        href="https://docgedsistemas.com.br/"
                        target="_blank"
                        rel="noopener noreferrer"
                        sx={{
                            textTransform: 'none',
                            fontWeight: 600,
                        }}
                    >
                        DocGed Sistemas
                    </Button>
                </Box>
            </Box>
        </Container>
    );
}

export default function PageNotFound() {
    return (
        <BaseLayoutFactory>
            <PageNotFoundComponent />
        </BaseLayoutFactory>
    );
}
